var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "unified-navigation-ui": "static-1.25671",
      "ably-hubspot-js": "static-2.2771",
      "breadcrumbs-ui": "static-1.857",
      "client-types": "static-1.358",
      "enviro": "static-4.284",
      "head-dlb": "static-1.3234",
      "hs-lodash": "static-4.40",
      "hs-promise-utils": "static-1.3665",
      "hs-test-utils": "static-1.6161",
      "hub-http": "static-1.4150",
      "hubspot-url-utils": "static-1.2652",
      "HubStyleTokens": "static-2.9696",
      "I18n": "static-7.1337",
      "jasmine-runner": "static-1.4557",
      "nav-client-types": "static-1.657",
      "nav-meta": "static-1.24464",
      "navigation-components": "static-1.12827",
      "navigation-components-tests": "static-1.9437",
      "navigation-messaging": "static-1.2154",
      "quartz": "static-1.4903",
      "react": "static-7.147",
      "react-dnd": "static-2.33",
      "react-dnd-html5-backend": "static-2.10",
      "react-redux": "static-7.16",
      "redux": "static-4.16",
      "rpc-client-utils": "static-1.2924",
      "target-element-observer": "static-1.240",
      "webpack-env": "static-1.54",
      "wootric-nps": "static-1.5191",
      "ably": "static-2.2",
      "calling-internal-common": "static-1.29277",
      "classnames": "static-2.10",
      "crosstab": "static-1.2805",
      "ExtensionInstallHelpers": "static-1.519",
      "foundations-components": "static-1.5259",
      "foundations-theming": "static-1.2407",
      "foundations-theming-base": "static-1.1392",
      "foundations-theming-specialty": "static-1.124",
      "frontend-preferences-client": "static-1.6067",
      "global-search-externals": "static-1.8730",
      "idb-keyval": "static-1.18",
      "magpie-lib": "static-1.3804",
      "magpie-types": "static-1.3264",
      "metrics-js": "static-1.7934",
      "nav-onboarding-tours": "static-1.1520",
      "notification-sounds": "static-1.2638",
      "prefetcher": "static-1.3948",
      "react-dom": "static-7.85",
      "react-utils": "static-2.3818",
      "redux-thunk": "static-2.43",
      "redux-toolkit": "static-1.7",
      "reselect": "static-2.16",
      "sanitize-text": "static-1.6375",
      "simple-logging-lib": "static-1.1252",
      "styled-components": "static-2.40",
      "superstore": "static-1.2968",
      "trial-components-library": "static-1.9863",
      "ts-schema": "static-1.2641",
      "ui-images": "static-2.780",
      "usage-tracker-core": "static-1.5509",
      "hs-promise-rejection-tracking": "static-1.3563",
      "PortalIdParser": "static-2.263",
      "raven": "static-3.3936",
      "raven-hubspot": "static-1.4243",
      "bend-plugin-trellis-migration": "static-1.1920",
      "moment": "static-3.26",
      "quartz-core": "static-1.4122",
      "HeadJS": "static-2.537",
      "framer-motion": "static-1.38",
      "hs-test-utils-bend-plugin": "static-1.1272",
      "msw": "static-1.39",
      "testing-library": "static-1.118",
      "i18n-data": "static-1.193",
      "moment-timezone": "static-5.51",
      "jasmine": "static-4.2550",
      "quartz-core-utils": "static-1.1770",
      "StyleGuideUI": "static-3.443",
      "csstype": "static-1.38",
      "hoist-non-react-statics": "static-3.9",
      "quick-fetch": "static-1.2224",
      "HubStyle": "static-2.10005",
      "calling-error-reporting": "static-1.29283",
      "calling-usage-tracker": "static-1.4671",
      "immer": "static-1.33",
      "immutable": "static-2.19",
      "self-service-api": "static-1.8300",
      "SharedI18nStrings": "static-1.160",
      "UIComponents": "static-3.6645",
      "bend-plugin-foundations-components": "static-1.1527",
      "floating-ui": "static-1.24",
      "foundations-assets": "static-1.3071",
      "hs-story-utils": "static-1.7477",
      "react-aria": "static-1.36",
      "react-select-plus": "static-1.65",
      "react-virtualized": "static-2.71",
      "tanstack-table": "static-1.23",
      "ui-fonts": "static-1.329",
      "bend-plugin-foundations-theming": "static-1.890",
      "hub-http-janus": "static-1.606",
      "global-search-shared": "static-1.9442",
      "usage-tracker": "static-1.5659",
      "autolinker": "static-3.11",
      "sanitize": "static-1.2555",
      "transmute": "static-2.29",
      "ai-components-ui-library": "static-1.4417",
      "atom": "static-1.3509",
      "copilot-toolkit": "static-1.4177",
      "demographics-client": "static-1.3593",
      "icons": "static-2.589",
      "laboratory-lib": "static-3.5449",
      "onboarding-scopes": "static-1.4748",
      "react-input-autosize": "static-2.17",
      "salesImages": "static-1.495",
      "signup-constants": "static-1.15041",
      "trials-service-types": "static-1.2321",
      "ui-addon-i18n": "static-1.9085",
      "ui-addon-upgrades": "static-9.15156",
      "user-context": "static-1.3333",
      "dispatcher": "static-1.108",
      "general-store": "static-6.20",
      "history": "static-4.47",
      "hub-http-shared-msw-handlers": "static-1.6308",
      "hubspotter-http": "static-1.3023",
      "hubspotter-http-shared-msw-handlers": "static-1.6306",
      "mobile-manifest-mixins": "static-1.308",
      "platform-navigation-bootstrap": "static-1.10377",
      "react-rhumb": "static-1.14772",
      "react-router-dom": "static-5.26",
      "cssUtils": "static-1.352",
      "customer-data-ui-utilities": "static-1.7909",
      "ai-addon-copilot-preview": "static-1.3629",
      "apollo-link-hub-http": "static-2.2991",
      "apollo-stack-hubspot": "static-3.43",
      "data-fetching-client": "static-1.7684",
      "graphql": "static-1.56",
      "search-service-types": "static-1.2238",
      "chatspot-client-types": "static-1.7651",
      "chatspot-core": "static-1.13370",
      "ContentUtils": "static-1.61193",
      "sassPrefix": "static-1.127",
      "feature-store-service-types": "static-1.2913",
      "growth-monetization-service-types": "static-1.2920",
      "upgrade-management-service-types": "static-1.2904",
      "getting-started-shared-tasks": "static-1.9528",
      "getting-started-shared-tasks-store": "static-1.8646",
      "platform-infra-nav-components": "static-1.6155",
      "react-dnd-compat": "static-1.2748",
      "react-immutable-proptypes": "static-2.8",
      "react-immutable-render-mixin": "static-1.9",
      "ai-settings-ui-library": "static-1.5009",
      "apollo-dlb": "static-3.41",
      "markdown-it": "static-1.6",
      "cms-field-types": "static-1.2980",
      "content-icons-ui": "static-1.1837",
      "underscore": "static-1.8",
      "ui-addon-avatars": "static-2.7610",
      "ui-addon-react-router-dom": "static-1.7792",
      "usage-tracker-container": "static-1.5649"
    },
    "depPathPrefixes": {
      "unified-navigation-ui": "/unified-navigation-ui/static-1.25671",
      "ably-hubspot-js": "/ably-hubspot-js/static-2.2771",
      "breadcrumbs-ui": "/breadcrumbs-ui/static-1.857",
      "client-types": "/client-types/static-1.358",
      "enviro": "/enviro/static-4.284",
      "head-dlb": "/head-dlb/static-1.3234",
      "hs-lodash": "/hs-lodash/static-4.40",
      "hs-promise-utils": "/hs-promise-utils/static-1.3665",
      "hs-test-utils": "/hs-test-utils/static-1.6161",
      "hub-http": "/hub-http/static-1.4150",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.2652",
      "HubStyleTokens": "/HubStyleTokens/static-2.9696",
      "I18n": "/I18n/static-7.1337",
      "jasmine-runner": "/jasmine-runner/static-1.4557",
      "nav-client-types": "/nav-client-types/static-1.657",
      "nav-meta": "/nav-meta/static-1.24464",
      "navigation-components": "/navigation-components/static-1.12827",
      "navigation-components-tests": "/navigation-components-tests/static-1.9437",
      "navigation-messaging": "/navigation-messaging/static-1.2154",
      "quartz": "/quartz/static-1.4903",
      "react": "/react/static-7.147",
      "react-dnd": "/react-dnd/static-2.33",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
      "react-redux": "/react-redux/static-7.16",
      "redux": "/redux/static-4.16",
      "rpc-client-utils": "/rpc-client-utils/static-1.2924",
      "target-element-observer": "/target-element-observer/static-1.240",
      "webpack-env": "/webpack-env/static-1.54",
      "wootric-nps": "/wootric-nps/static-1.5191",
      "ably": "/ably/static-2.2",
      "calling-internal-common": "/calling-internal-common/static-1.29277",
      "classnames": "/classnames/static-2.10",
      "crosstab": "/crosstab/static-1.2805",
      "ExtensionInstallHelpers": "/ExtensionInstallHelpers/static-1.519",
      "foundations-components": "/foundations-components/static-1.5259",
      "foundations-theming": "/foundations-theming/static-1.2407",
      "foundations-theming-base": "/foundations-theming-base/static-1.1392",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.124",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.6067",
      "global-search-externals": "/global-search-externals/static-1.8730",
      "idb-keyval": "/idb-keyval/static-1.18",
      "magpie-lib": "/magpie-lib/static-1.3804",
      "magpie-types": "/magpie-types/static-1.3264",
      "metrics-js": "/metrics-js/static-1.7934",
      "nav-onboarding-tours": "/nav-onboarding-tours/static-1.1520",
      "notification-sounds": "/notification-sounds/static-1.2638",
      "prefetcher": "/prefetcher/static-1.3948",
      "react-dom": "/react-dom/static-7.85",
      "react-utils": "/react-utils/static-2.3818",
      "redux-thunk": "/redux-thunk/static-2.43",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "reselect": "/reselect/static-2.16",
      "sanitize-text": "/sanitize-text/static-1.6375",
      "simple-logging-lib": "/simple-logging-lib/static-1.1252",
      "styled-components": "/styled-components/static-2.40",
      "superstore": "/superstore/static-1.2968",
      "trial-components-library": "/trial-components-library/static-1.9863",
      "ts-schema": "/ts-schema/static-1.2641",
      "ui-images": "/ui-images/static-2.780",
      "usage-tracker-core": "/usage-tracker-core/static-1.5509",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.3563",
      "PortalIdParser": "/PortalIdParser/static-2.263",
      "raven": "/raven/static-3.3936",
      "raven-hubspot": "/raven-hubspot/static-1.4243",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.1920",
      "moment": "/moment/static-3.26",
      "quartz-core": "/quartz-core/static-1.4122",
      "HeadJS": "/HeadJS/static-2.537",
      "framer-motion": "/framer-motion/static-1.38",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.1272",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.118",
      "i18n-data": "/i18n-data/static-1.193",
      "moment-timezone": "/moment-timezone/static-5.51",
      "jasmine": "/jasmine/static-4.2550",
      "quartz-core-utils": "/quartz-core-utils/static-1.1770",
      "StyleGuideUI": "/StyleGuideUI/static-3.443",
      "csstype": "/csstype/static-1.38",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "quick-fetch": "/quick-fetch/static-1.2224",
      "HubStyle": "/HubStyle/static-2.10005",
      "calling-error-reporting": "/calling-error-reporting/static-1.29283",
      "calling-usage-tracker": "/calling-usage-tracker/static-1.4671",
      "immer": "/immer/static-1.33",
      "immutable": "/immutable/static-2.19",
      "self-service-api": "/self-service-api/static-1.8300",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.160",
      "UIComponents": "/UIComponents/static-3.6645",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.1527",
      "floating-ui": "/floating-ui/static-1.24",
      "foundations-assets": "/foundations-assets/static-1.3071",
      "hs-story-utils": "/hs-story-utils/static-1.7477",
      "react-aria": "/react-aria/static-1.36",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-virtualized": "/react-virtualized/static-2.71",
      "tanstack-table": "/tanstack-table/static-1.23",
      "ui-fonts": "/ui-fonts/static-1.329",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.890",
      "hub-http-janus": "/hub-http-janus/static-1.606",
      "global-search-shared": "/global-search-shared/static-1.9442",
      "usage-tracker": "/usage-tracker/static-1.5659",
      "autolinker": "/autolinker/static-3.11",
      "sanitize": "/sanitize/static-1.2555",
      "transmute": "/transmute/static-2.29",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.4417",
      "atom": "/atom/static-1.3509",
      "copilot-toolkit": "/copilot-toolkit/static-1.4177",
      "demographics-client": "/demographics-client/static-1.3593",
      "icons": "/icons/static-2.589",
      "laboratory-lib": "/laboratory-lib/static-3.5449",
      "onboarding-scopes": "/onboarding-scopes/static-1.4748",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "salesImages": "/salesImages/static-1.495",
      "signup-constants": "/signup-constants/static-1.15041",
      "trials-service-types": "/trials-service-types/static-1.2321",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.9085",
      "ui-addon-upgrades": "/ui-addon-upgrades/static-9.15156",
      "user-context": "/user-context/static-1.3333",
      "dispatcher": "/dispatcher/static-1.108",
      "general-store": "/general-store/static-6.20",
      "history": "/history/static-4.47",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.6308",
      "hubspotter-http": "/hubspotter-http/static-1.3023",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.6306",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.308",
      "platform-navigation-bootstrap": "/platform-navigation-bootstrap/static-1.10377",
      "react-rhumb": "/react-rhumb/static-1.14772",
      "react-router-dom": "/react-router-dom/static-5.26",
      "cssUtils": "/cssUtils/static-1.352",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.7909",
      "ai-addon-copilot-preview": "/ai-addon-copilot-preview/static-1.3629",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.2991",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.43",
      "data-fetching-client": "/data-fetching-client/static-1.7684",
      "graphql": "/graphql/static-1.56",
      "search-service-types": "/search-service-types/static-1.2238",
      "chatspot-client-types": "/chatspot-client-types/static-1.7651",
      "chatspot-core": "/chatspot-core/static-1.13370",
      "ContentUtils": "/ContentUtils/static-1.61193",
      "sassPrefix": "/sassPrefix/static-1.127",
      "feature-store-service-types": "/feature-store-service-types/static-1.2913",
      "growth-monetization-service-types": "/growth-monetization-service-types/static-1.2920",
      "upgrade-management-service-types": "/upgrade-management-service-types/static-1.2904",
      "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.9528",
      "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.8646",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.6155",
      "react-dnd-compat": "/react-dnd-compat/static-1.2748",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "ai-settings-ui-library": "/ai-settings-ui-library/static-1.5009",
      "apollo-dlb": "/apollo-dlb/static-3.41",
      "markdown-it": "/markdown-it/static-1.6",
      "cms-field-types": "/cms-field-types/static-1.2980",
      "content-icons-ui": "/content-icons-ui/static-1.1837",
      "underscore": "/underscore/static-1.8",
      "ui-addon-avatars": "/ui-addon-avatars/static-2.7610",
      "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.7792",
      "usage-tracker-container": "/usage-tracker-container/static-1.5649"
    },
    "project": "unified-navigation-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};